<div class="header">
  <h4 class="header4-text">Database Tools</h4>
</div>

<app-subscription-card-list
  class="database-tools-card-list"
  [subscriptions]="dataBaseTools"
  (clickSubscriptionCard)="onDataBaseToolsClick($event)"
></app-subscription-card-list>
